import React from 'react'

export default function CategoryDetail({ filterData, caterogoyName, fontColor }) {
  return (
    <section>
      <div
        className="category-by-shoes-banner-details-section"
        style={{ borderRadius: caterogoyName === 'accessories' ? '16px' : '' }}
      >
        <div className="category-by-shoes-banner">
          {filterData?.banner_media && <img src={filterData?.banner_media} alt="womens_images" />}
        </div>
        <div className="category-by-shoes-banner-section">
          <div className="container">
            <div className="category-by-shoes-heading-alignment">
              <h4 style={{ color: fontColor }}>{filterData?.name}</h4>
              <p style={{ color: fontColor }}>{filterData?.description}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
